// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"82b4b57a","420":"f204eb16","560":"2a3b56e9","569":"d9f3a325","598":"3ebc850b","635":"f204eb16","978":"a65205e8"}[chunkId] + ".chunk.css";
};